import { render, staticRenderFns } from "./GraphCategory.vue?vue&type=template&id=74664c39&scoped=true"
import script from "./GraphCategory.vue?vue&type=script&lang=js"
export * from "./GraphCategory.vue?vue&type=script&lang=js"
import style0 from "./GraphCategory.vue?vue&type=style&index=0&id=74664c39&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74664c39",
  null
  
)

export default component.exports